<template>
    <!-- Low-profit warning for a quote in a list. `check` is one entry of admin/quotes/profit_checks;
         nothing shows unless the quote has a minimum (location margin or company minimum) and the profit is below it. -->
    <v-tooltip bottom v-if="check && check.applies && check.is_low">
        <template v-slot:activator="{ on, attrs }">
            <v-chip x-small color="#D32F2F" dark class="mt-1 mb-2" v-bind="attrs" v-on="on">
                <v-icon x-small left>mdi-alert</v-icon>Low profit
            </v-chip>
        </template>
        <span>
            Profit {{ currency }}{{ money(check.profit) }} per person, below the {{ currency }}{{ money(check.minimum) }}
            <template v-if="check.minimum_source === 'company'">company minimum ({{ check.location || 'location' }} has no margin)</template>
            <template v-else>minimum for {{ check.location || 'this location' }}</template>
            <template v-if="check.checked_at"><br>Marked as OK on the Low Profit report</template>
        </span>
    </v-tooltip>
</template>

<script>
export default {
    props: ['check', 'currency'],
    methods: {
        money(value) {
            return Number(value || 0).toFixed(2)
        },
    },
}
</script>
